<div class="colors">
  <div></div>
  <div></div>
  <div></div>
  <div></div>
</div>
<div class="header-content">
 <img class="iconSocial" src="assets/img/{{Empresa}}/logo.png" height="100%" alt="" />
  <div>
    <span _ngcontent-c3="" style="width : 100%; text-align: center;"> {{ 'VERSION' | translate }}: 1.8.3</span>
  </div>
  <div class="fecha-hora">
    {{ fecha | date: 'EEEE d, MMMM yyyy - H:mm':localeId }}
  </div>
  <div class="user" *ngIf="turno">
    <img class="svg" src="assets/img/icon-user.svg" alt="icono usuario" />
    <div class="name">{{ turno.NombreUsuario }}</div>
  </div>
  <div class="icon-section" *ngIf="turno">
    <img class="svg" src="assets/img/icon-timer.svg" alt="icono timer" />
    <div class="text">{{ turno.pkid }}</div>
  </div>
  <div class="icon-section" *ngIf="turno">
    <img class="svg" src="assets/img/icon-shop.svg" alt="icono shop" />
    <div class="text">{{ turno.NombreTPV }}</div>
  </div>
  <!--<div class="icon-section">
    <button type="button" (click)="setLang('es-ES')"> ES</button>
    <button type="button" (click)="setLang('en-EN')"> EN</button>
    <button type="button" (click)="setLang('ca-CA')"> CAT</button>
  </div>-->
  <div class="user-menu">
    <a (click)="logOut()" title="menu">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </a>
  </div>
</div>
